module.exports = __webpack_public_path__ + "acc7fdc06690e8389cdecfbf31fafb2a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/earrings-pearl.png
// module id = 2801
// module chunks = 0